// extracted by mini-css-extract-plugin
export default {"tabletMinViewport":"768px","desktopMinViewport":"1024px","smallScreenHeight":"970px","errorConePage":"w3yLb6","mobile":"U6dXcA"};